import {
  adModal,
  adModalClickAction,
  adModalTypeImage,
  adModalTypeText,
  adModalUTM,
  adModalUTMRemove,
  goToTargetingModal
} from './ad-modal';
import {
  campaignModal,
  campaignModalCategories,
  campaignModalFolders,
  campaignModalName,
  campaignModalSchedule,
  campaignModalScheduleDates,
  campaignModalTags,
  goToAdModal
} from './campaign-modal';
import { clickNewCampaign } from './click-new-campaign';
import { creatingCampaign } from './creating-campaign';
import { clickCreateCampaign, targetingModal, targetingModalDomain, targetingModalRecipient } from './targeting-modal';

let createSteps = [
  creatingCampaign,
  clickNewCampaign,
  campaignModal,
  campaignModalName,
  campaignModalSchedule,
  campaignModalScheduleDates,
  campaignModalTags,
  campaignModalCategories,
  campaignModalFolders,
  goToAdModal,
  adModal,
  adModalClickAction,
  adModalUTM,
  adModalUTMRemove,
  adModalTypeText,
  adModalTypeImage,
  goToTargetingModal,
  targetingModal,
  targetingModalRecipient,
  targetingModalDomain,
  clickCreateCampaign
];

export const CREATE_STEPS = createSteps;
